export const ROUTE_CODES = {
  USER: "USERS",
  ROLES: "ROLE_CRUD",
  ROLE_FEATURE_MAP: "ROLE_FEATURE_MAP",
  USER_FEATURE_MAP: "USER_FEATURE_MAP",
  COMPANY_PROFILE: "COMPANY_PROFILE",
  INVOICE_LIST: "INVOICE_LIST",
  API_CREDENTIALS: "API_CREDENTIALS",
};
